import React, { useEffect, useState } from 'react';
import EraseCheck from '../../MySections/PopUps/EraseCheck';
import UserPermission from '../OrdersP/OrdersList-list/UserPermission';

const ListUsersTable = (props) => {
    const [tempoUsersList, setTempoUsersList] = useState(props.usersList);
    const [thePopUp, setThePopUp] = useState("");

    useEffect(() => {

    }, [])

    useEffect(() => {
        setTempoUsersList(props.usersList)
    }, [props.usersList])

    const updatePermiss = async (newVal, usrId) => {
        let temp = [...tempoUsersList]
        let itmIndx = temp.findIndex(it => it._id == usrId);
        temp[itmIndx].permiss = newVal;
        setTempoUsersList(temp)

        props.updateList(temp)
        //setTempList([...tempList, itm])

    }


    const setUserBuis = async (newVal, usrId) => {
        let temp = [...tempoUsersList]
        let itmIndx = temp.findIndex(it => it._id == usrId);
        temp[itmIndx].buisID = newVal;
        setTempoUsersList(temp)

        props.updateList(temp)


    }

    const blockUser = (index, newVal) => {
        let temp = [...tempoUsersList]
        temp[index].blocked = newVal;
        setTempoUsersList(temp)

        props.updateList(temp)

    }

    const setFirstName = (index, newVal) => {
        let temp = [...tempoUsersList]
        temp[index].firstName = newVal;
        setTempoUsersList(temp)

        props.updateList(temp)

    }
    const setLastName = (index, newVal) => {
        let temp = [...tempoUsersList]
        temp[index].lastName = newVal;
        setTempoUsersList(temp)

        props.updateList(temp)
    }


    const setPassword = (index, newVal) => {
        let temp = [...tempoUsersList]
        temp[index].password = newVal;
        setTempoUsersList(temp)

        props.updateList(temp)
    }


    const setPhone = (index, newVal) => {
        let temp = [...tempoUsersList]
        temp[index].phone = newVal;
        setTempoUsersList(temp)

        props.updateList(temp)
    }

    const setEmail = (index, newVal) => {
        let temp = [...tempoUsersList]
        temp[index].email = newVal;
        setTempoUsersList(temp)

        props.updateList(temp)

    }

    const removeUser = (indx) => {

        setThePopUp(<EraseCheck title={'האם בטוח למחוק את המשתמש?'}
            sucecssFunc={() => removeOptConfirmd(indx)} />)
    }

    const removeOptConfirmd = async (indx) => {

        let temp = [...tempoUsersList];
        let itmeToErease = temp[indx]
        props.addToDelete(itmeToErease)

        temp.splice(indx, 1)

        setTempoUsersList(temp)

        props.updateList(temp)



    }



    return (
        <div className="ms-panel-body">
            <div className="table-responsive">
                <table className="table table-hover thead-primary">
                    <thead>
                        <tr>
                            <th scope="col">שם פרטי</th>
                            <th scope="col">שם משפחה</th>
                            <th scope="col">טלפון</th>
                            <th scope="col">מייל</th>
                            <th scope="col">סיסמא</th>
                            <th scope="col">הרשאות</th>
                            <th scope="col">עסק</th>
                            <th scope="col">מחק</th>
                            <th scope="col">חסום</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tempoUsersList.map((item, index) => {
                            let itmBlock = (item.blocked == undefined || item.blocked == false) ? false : true;



                            return (
                                <tr key={item._id} itmid={item._id}>
                                    <td scope="row">
                                        <div className={"textRight"}>
                                            <input type="text" className={"form-control"} placeholder={"שם פרטי"}
                                                value={item.firstName}
                                                onChange={(e) => { setFirstName(index, e.target.value) }} />
                                        </div>
                                    </td>
                                    <td scope="row">
                                        <div className={"textRight"}>
                                            <input type="text" className={"form-control"} placeholder={"שם משפחה"}
                                                value={item.lastName}
                                                onChange={(e) => { setLastName(index, e.target.value) }} />
                                        </div>
                                    </td>
                                    <td scope="row">
                                        <div className={"textRight"}>
                                            <input type="text" className={"form-control"} placeholder={"טלפון"}
                                                value={item.phone}
                                                onChange={(e) => { setPhone(index, e.target.value) }} />
                                        </div>
                                    </td>
                                    <td scope="row" style={{ direction: 'ltr' }}>
                                        <div className={"textRight"}>
                                            <input type="text" className={"form-control"} placeholder={"אימייל"}
                                                value={item.email}
                                                onChange={(e) => { setEmail(index, e.target.value) }} />
                                        </div>
                                    </td>
                                    <td scope="row" style={{ direction: 'ltr' }}>
                                        <div className={"textRight"}>
                                            <input type="text" className={"form-control"} placeholder={"סיסמא"}
                                                value={item.password}
                                                onChange={(e) => { setPassword(index, e.target.value) }} />
                                        </div>
                                    </td>
                                    <td className={"textRight pointing specialBlkWr"} >
                                        <UserPermission clss={"buisSelectOnTable onLeft"}
                                            UserPermiss={item.permiss}
                                            key={index}
                                            setUserPermiss={(newVal) => { updatePermiss(newVal, item._id) }}
                                        />
                                    </td>
                                    <td className={"textRight pointing specialBlkWr"} >
                                    נפוליאון אשדוד
                                    </td>
                                    <td>
                                        <div className={"divAsIcon pointing"} onClick={() => removeUser(index)}><i className="far fa-trash-alt ms-text-danger" /></div>
                                    </td>
                                    <td>
                                        <input type="checkbox" checked={itmBlock} onChange={(e) => blockUser(index, !itmBlock)} /> <i className="ms-checkbox-check" />
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {thePopUp}
        </div>
    )
}

export default ListUsersTable;